import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';
import {Container, Typography} from '@mui/material';
import {CarePlanActivityTypesArrangement} from '../../../backend/enums/care-plan-activity-types-arrangement';

export const NoActivities = ({layout}: {layout: CarePlanActivityTypesArrangement}) => {
  const {t} = useTranslation();

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '100%',
        justifyContent:
          layout === CarePlanActivityTypesArrangement.Columns ? 'flex-start' : 'center',
      }}
    >
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          letterSpacing: '0.25px',
          color: 'var(--dcm-gray-general)',
        }}
      >
        {t(translations.activities_group_entry.no_activity_types)}
      </Typography>
    </Container>
  );
};
